import { useContext } from 'react';

import { GoalTemplatePreviewContext } from './goal-template-preview-context';

export const useShowGoalTemplatePreview = () => {
  const { openGoalTemplatePreview } = useContext(GoalTemplatePreviewContext);

  return openGoalTemplatePreview;
};
